import { Col, Image, Row, Table, Tag } from 'antd';
import { Helmet } from 'react-helmet-async';
import { useEffect, useState } from 'react';
import { apiCall } from '../../API/RestApi';
import { useSelector } from 'react-redux';
import { currencyFormat } from '../../Utils/formatCurrency';
import { useLocation } from 'react-router-dom';
import { getStatusApproval } from '../../Utils/approval';

function SettlementDetail() {
    const token = useSelector((state) => state.user.token);
    const location = useLocation();
    const [data, setData] = useState(null);
    const [benefit, setBenefit] = useState(null);
    const [approval, setApproval] = useState([]);
    const [costTransportation, setCostTransportation] = useState([]);
    const [activityImage, setActivityImage] = useState([]);
    const [report, setReport] = useState([]);
    const [totalCost, setTotalCost] = useState(0);
    const [loading, setLoading] = useState(false);

    const titlePage = 'Business Trip Application Data';

    const columns = [
        {
            title: 'No',
            dataIndex: 'no',
            key: "no",
            render: (id, record, index) => { ++index; return index },
        },
        {
            title: 'Name',
            dataIndex: 'name',
            key: "name",
            render: (text, record) => record.users.name,
        },
        {
            title: 'Position',
            dataIndex: 'position',
            key: "position",
            render: (text, record) => record.users.position.name,
        },
        {
            title: 'Division',
            dataIndex: 'division',
            key: "division",
            render: (text, record) => record.users.division.name,
        },
        {
            title: 'Description',
            dataIndex: 'desc',
            key: "desc",
        },
        {
            title: 'Status',
            dataIndex: 'status',
            key: "status",
            render: (text, record) => {
                const statusColor = record.status_approval.status_approval_id === 1 ? 'blue' :
                    record.status_approval.status_approval_id === 2 ? 'green' : 'red';
                return (<Tag color={statusColor}>{record.status_approval.status}</Tag>);
            },
        },
    ];

    const reportColumns = [
        { title: 'No', dataIndex: 'no', key: 'no', render: (id, record, index) => ++index },
        { title: 'City', dataIndex: 'city', key: 'city' },
        { title: 'PIC', dataIndex: 'pic', key: 'pic' },
        { title: 'Address', dataIndex: 'address', key: 'address' },
        { title: 'Store Type', dataIndex: 'store_type', key: 'store_type' },
        { title: 'Consumer Traffic', dataIndex: 'consumer_traffic', key: 'consumer_traffic' },
        { title: 'Store Background', dataIndex: 'store_background', key: 'store_background' },
        { title: 'Potential', dataIndex: 'potency', key: 'potency', render: (text, record) => currencyFormat(record.potency) },
        { title: 'Target Realization', dataIndex: 'target_realization', key: 'target_realization' },
        { title: 'Visitation Update', dataIndex: 'visitation_update', key: 'visitation_update' },
    ];

    const activityColumns = [
        { title: 'No', dataIndex: 'no', key: 'no', render: (id, record, index) => ++index },
        {
            title: 'Photo Proof',
            dataIndex: 'image',
            key: 'image',
            render: (text, record) => record.image ? <Image width={50} height={50} src={record.image} /> : <p>no image</p>
        },
        { title: 'Store Name', dataIndex: 'store_name', key: 'store_name' },
        { title: 'City', dataIndex: 'city', key: 'city' },
    ];

    const CostColumns = [
        { title: 'No', dataIndex: 'no', key: 'no', render: (id, record, index) => ++index },
        {
            title: 'Photo Proof',
            dataIndex: 'image',
            key: 'image',
            render: (text, record) => record.image ? <Image width={50} height={50} src={record.image} /> : <p>no image</p>
        },
        { title: 'Cost Name', dataIndex: 'name', key: 'name' },
        { title: 'Cost', dataIndex: 'cost', key: 'cost', render: (text, record) => currencyFormat(record.cost) },
    ];

    useEffect(() => {
        if (location.state) {
            getApi("GET", `/settlement/${location.state.item.settlement_id}`, 'request');
        }
    }, []);

    const getApi = (method, url, type) => {
        setLoading(true);
        const dataReq = {
            method,
            url,
            data: {
                headers: { Authorization: 'Bearer ' + token }
            }
        };
        apiCall(dataReq).then((res) => {
            if (res.status === "success") {
                if (type === 'request') {
                    getApi("GET", `/benefitlevel?leveldetail=${res.data.user.level_detail_id}`, 'benefit');
                    setData(res.data);
                    setApproval(res.data.approval);
                    setCostTransportation(res.data.cost_transportation);
                    setActivityImage(res.data.activity_image);
                    setReport(res.data.report_submission);
                    const totalCostCalc = res.data.cost_transportation.reduce((sum, item) => sum + Number(item.cost), 0);
                    setTotalCost(totalCostCalc);
                } else if (type === 'benefit') {
                    setBenefit(res.data.data[0]);
                }
                setLoading(false);
            } else {
                setLoading(false);
            }
        }).catch((e) => {
            setLoading(false);
            console.error(e.message);
        });
    };

    const checkStatus = () => (<Tag color={getStatusApproval(data).color}>{getStatusApproval(data).value}</Tag>);

    if (data && benefit) return (
        <div>
            <Helmet><title>{titlePage}</title></Helmet>
            <h1>{data.budget_submission_code}</h1>
            <h3>Title: {data.title}</h3>
            {checkStatus()}

            <h4>Submitted By</h4>
            <Row>
                <Col><div>Name</div><div>Position</div><div>Division</div></Col>
                <Col><div>: {data.user.name}</div><div>: {data.user.position.name}</div><div>: {data.user.division.name}</div></Col>
            </Row>

            <hr />
            <h3>Details</h3>
            <Row>
                <Col span={12}>
                    <h4>Information</h4>
                    <Row>
                        <Col><div>Description</div><div>Total Cost</div></Col>
                        <Col><div>: {data.desc}</div><div>: <b>{currencyFormat(totalCost)}</b></div></Col>
                    </Row>
                </Col>
                <Col span={12}>
                    <h4>Approval By</h4>
                    <Table size="middle" columns={columns} dataSource={approval} pagination={false} />
                </Col>
            </Row>

            <Row>
                <Col span={11}>
                    <h4>Location Activity</h4>
                    <Table size="middle" columns={activityColumns} dataSource={activityImage} pagination={false} />
                </Col>
                <Col span={1} />
                <Col span={12}>
                    <h4>Travel Expenses</h4>
                    <Table size="middle" columns={CostColumns} dataSource={costTransportation} pagination={false} />
                </Col>
            </Row>

            <br />
            <h4>Report</h4>
            <Table size="middle" columns={reportColumns} dataSource={report} pagination={false} />
        </div>
    );
}

export default SettlementDetail;
